import { gql } from 'graphql-tag';
import { TypedDocumentNode } from '@apollo/client';

import {
  GetPostLikers,
  GetPostLikersVariables,
  GetPostLikes,
  GetPostLikesVariables,
} from '@generated/graphql';
import { ImageFragments } from '@graphql/fragments/rutilus/ImageType';
import { PostFragments, PostEntryFieldsFragment } from '@graphql/fragments/rutilus/PostType';
import { UserFragments } from '@graphql/fragments/rutilus/UserType';
import { CatchFragments } from '@graphql/fragments/rutilus/CatchType';

export const getPost = gql`
  query GetPost($externalId: String) {
    entry: post(externalId: $externalId) {
      ...PostEntryFields
    }
  }
  ${PostEntryFieldsFragment}
`;

export const getPostMetadata = gql`
  query GetPostMetadata($externalId: String) {
    entry: post(externalId: $externalId) {
      ...PostId
      externalId
      catch {
        ...CatchId
      }
      text {
        text
      }
      images(first: 1, width: 960) {
        edges {
          node {
            ...ImageFields
          }
        }
      }
      ...PostVideoFields
      user {
        nickname
      }
    }
  }
  ${PostFragments.id}
  ${PostFragments.videoFields}
  ${CatchFragments.id}
  ${ImageFragments.imageFields}
`;

export const getPostExternalId = gql`
  query GetPostExternalId($id: Int) {
    entry: post(id: $id) {
      ...PostId
    }
  }
  ${PostFragments.id}
`;

export const getPostComments = gql`
  query GetPostComments($externalId: String, $first: Int, $after: String) {
    entry: post(externalId: $externalId) {
      ...PostId
      comments(first: $first, after: $after) {
        pageInfo {
          endCursor
          startCursor
          hasNextPage
        }
        totalCount
        edges {
          cursor
          node {
            ...PostId
            createdAt
            user {
              ...UserId
              nickname
              ...UserAvatar
            }
            text {
              text
            }
            likedByCurrentUser
            likesCount
            comments(first: 20) {
              totalCount
              edges {
                node {
                  ...PostId
                  createdAt
                  user {
                    ...UserId
                    nickname
                    ...UserAvatar
                  }
                  text {
                    text
                  }
                  likedByCurrentUser
                  likesCount
                }
              }
            }
          }
        }
      }
    }
  }
  ${UserFragments.avatar}
  ${PostFragments.id}
  ${UserFragments.id}
`;

export const getPostLikers: TypedDocumentNode<GetPostLikers, GetPostLikersVariables> = gql`
  query GetPostLikers($externalId: String) {
    post(externalId: $externalId) {
      ...PostId
      likers(last: 12) {
        edges {
          node {
            ...PostLikerUserFields
          }
        }
      }
    }
  }
  ${PostFragments.id}
  ${UserFragments.postLikerUserFields}
`;

export const getPostLikes: TypedDocumentNode<GetPostLikes, GetPostLikesVariables> = gql`
  query GetPostLikes($externalId: String) {
    post(externalId: $externalId) {
      ...PostId
      likedByCurrentUser
      likesCount
    }
  }
  ${PostFragments.id}
`;
